export default "__VITE_ASSET__e0e0fc61__"